import { getMerchantInstance } from './apiService';

const SupplierServices = {
  get: ({ page, size, sort }) => {
    return getMerchantInstance().get(
      `partner?partnerCategoryTypeIn=SUPPLIER&sortBy=${sort ?? 'createdAt:DESC'}&page=${page ??
        0}&size=${size ?? 10}`,
    );
  },
  update: ({ id, data }) => {
    return getMerchantInstance().put(`partner${id}`, data);
  },
  create: payload => {
    return getMerchantInstance().post('partner', payload);
  },
  delete: ids => {
    return getMerchantInstance().delete(`partner/bulk?ids=${ids.join(',')}`);
  },
};

export default SupplierServices;
